import { render, staticRenderFns } from "./NYTLatest.vue?vue&type=template&id=7b758d1b&"
import script from "./NYTLatest.vue?vue&type=script&lang=js&"
export * from "./NYTLatest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports